import { render, staticRenderFns } from "./PDFViewerWithImage.vue?vue&type=template&id=3bac99a5&scoped=true"
import script from "./PDFViewerWithImage.vue?vue&type=script&lang=js"
export * from "./PDFViewerWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac99a5",
  null
  
)

export default component.exports